import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import LocationSvg from 'src/components/svg/LocationSvg';
import { useLocationContext } from 'src/lib/contexts/LocationContext';
import classNames from 'classnames';
import styles from './LocationResult.module.css';

//#region [Styles]
// migrated to CSS Modules
//#endregion

//#region [Props]
type LocationResultProps = {
	locationName: string;
	className?: string;
	onClick: (event: React.MouseEvent) => void;
};
//#endregion

//#region [Component]
export default function LocationResult({ locationName, onClick, className }: LocationResultProps) {
	const locationContext = useLocationContext();

	return <FilmwebLink
		to={`/program?location=${locationName}`}
		className={classNames(styles.SLocationResult, className)}
		onClick={e => { onClick(e); locationContext.setLocation(locationName); }}
	>
		<div className={styles.SLocationIcon}>
			<LocationSvg className={styles.SLocationSvg} />
		</div>
		<div className={styles.SLocationName}>
			{locationName}
		</div>
	</FilmwebLink>;
}
//#endregion
